import { render, staticRenderFns } from "./ListCard.vue?vue&type=template&id=04b4fd3a&"
import script from "./ListCard.vue?vue&type=script&lang=js&"
export * from "./ListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b4fd3a')) {
      api.createRecord('04b4fd3a', component.options)
    } else {
      api.reload('04b4fd3a', component.options)
    }
    module.hot.accept("./ListCard.vue?vue&type=template&id=04b4fd3a&", function () {
      api.rerender('04b4fd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/components/ListCard.vue"
export default component.exports